import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCarouselArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "translate(8 0) scale(-1 1)",
		d: "M0.355353 0.368312C-0.118451 0.857285 -0.118451 1.64716 0.355353 2.13614L5.0691 7.00079L0.355353 11.8654C-0.118451 12.3544 -0.118451 13.1443 0.355353 13.6333C0.829157 14.1222 1.59453 14.1222 2.06834 13.6333L7.64465 7.87843C8.11845 7.38946 8.11845 6.59958 7.64465 6.11061L2.06834 0.355774C1.60668 -0.120661 0.829157 -0.120661 0.355353 0.368312Z",
		fill: "#3D4D59"
	})
});
export default SvgIconCarouselArrowLeft;
